var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingItem3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76001 2.96709C2.76001 2.22909 3.55727 1.76643 4.19802 2.13258L14.7557 8.16555C15.4014 8.53453 15.4014 9.46559 14.7557 9.83457L4.19802 15.8675C3.55727 16.2337 2.76001 15.771 2.76001 15.033V2.96709Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingItem3);
export default __webpack_public_path__ + "static/media/loading-item-3.fe941bd846a9bb0799cdca86873e23f5.svg";
export { ForwardRef as ReactComponent };